import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css'; // Ensure styles are imported

const DonatePage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="donate-page-container page-container">
      <h1 className="page-title">{t('donate_page_title')}</h1>

      <section className="donate-intro">
        <h2>{t('donate_intro_title')}</h2>
        <p>{t('donate_intro_text1')}</p>
        <p>{t('donate_intro_text2')}</p>
      </section>

      <section className="donation-options">
        <h3>{t('donate_options_title')}</h3>
        <div className="options-grid">
          <div className="donation-option-card">
            <h4>{t('donate_option_onetime_title')}</h4>
            <p>{t('donate_option_onetime_desc')}</p>
            {/* Placeholder for amount input or buttons */}
            <button className="button-primary donate-option-button">{t('donate_button_onetime')}</button>
          </div>
          <div className="donation-option-card">
            <h4>{t('donate_option_monthly_title')}</h4>
            <p>{t('donate_option_monthly_desc')}</p>
            {/* Placeholder for amount input or buttons */}
            <button className="button-primary donate-option-button">{t('donate_button_monthly')}</button>
          </div>
          <div className="donation-option-card">
            <h4>{t('donate_option_program_title')}</h4>
            <p>{t('donate_option_program_desc')}</p>
            {/* Placeholder for selecting a program */}
            <button className="button-secondary donate-option-button">{t('donate_button_program')}</button>
          </div>
        </div>
      </section>

      <section className="donate-cta">
        <h3>{t('donate_cta_title')}</h3>
        <p>{t('donate_cta_text')}</p>
        {/* This could link to an external donation platform or a more detailed form */}
        <button className="button-primary button-large donate-now-button">{t('donate_now_button')}</button>
      </section>

      <section className="other-ways-to-give">
          <h4>{t('donate_other_ways_title')}</h4>
          <p>{t('donate_other_ways_text')}</p>
          {/* Add details for mail, DAFs, etc. */}
      </section>

    </div>
  );
};

export default DonatePage;
